import API from "@/api/lib/api";

export const getAllFishChips = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/fish-chips`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleFishChips = async (item_id) => {
  try {
    const response = await API.get(`restaurant/fish-chips/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const createFishChips = async (data) => {
  try {
    const response = await API.post(`restaurant/fish-chips`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};



export const updateFishChips = async (item_id, data) => {
  try {
    const response = await API.put(`restaurant/fish-chips/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const deleteFishChips = async (item_id) => {
  try {
    const response = await API.delete(`restaurant/fish-chips/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};